import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {catchError, Observable, throwError} from 'rxjs';
import {Campaign, CampaignPost, GenerateTokensResponse, PaginatedResponse, Token} from './campaign.interface';

@Injectable({
  providedIn: 'root'
})
export class CampanasService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/campaigns`;
  private apiRute = '/client';
  private apiTokensUrl = `${environment.apiUrl}/tokens/campaign`;

  getCampaigns(clientPublicId: string): Observable<PaginatedResponse<Campaign>> {
    return this.http.get<PaginatedResponse<Campaign>>(`${this.apiUrl}${this.apiRute}/${clientPublicId}`)
      .pipe(catchError(this.handleError));
  }

  getCampaign(id: string): Observable<Campaign> {
    return this.http.get<Campaign>(`${this.apiUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  generateTokensCampain(campaignId: string, numberOfTokens: number): Observable<GenerateTokensResponse> {
    const body = {
      campaignId,
      numberOfTokens
    };
    return this.http.post<GenerateTokensResponse>(`${this.apiTokensUrl}`, body)
      .pipe(catchError(this.handleError));
  }

  getTokensCampain(campaignId: string, ): Observable<Token[]> {
    return this.http.get<Token[]>(`${this.apiUrl}/${campaignId}/tokens`, )
      .pipe(catchError(this.handleError));
  }


  createCampaign(campaign: CampaignPost): Observable<Campaign> {
    return this.http.post<Campaign>(this.apiUrl, campaign)
      .pipe(catchError(this.handleError));
  }

  updateCampaign(id: string, campaign: CampaignPost): Observable<Campaign> {
    return this.http.put<Campaign>(`${this.apiUrl}/${id}`, campaign)
      .pipe(catchError(this.handleError));
  }

  deleteCampaign(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMsg = 'Ocurrió un error inesperado';
    if (error.error && error.error.message) {
      errorMsg = error.error.message;
      console.log(errorMsg);
    }
    console.log(errorMsg);
    return throwError(() => new Error(errorMsg));

  }
}
